var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"page-shop_items"}},[_c('h5',{staticClass:"m-4"},[_vm._v(_vm._s(_vm.$t('AUTH.MENU.ORDERS')))]),_c('ShopOrderTable',{ref:"shop_orders_table",attrs:{"shop_orders":_vm.shop_orders},on:{"shop_order_selected":_vm.shop_order_selected}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }